// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import Attendee from '../attendee/Attendee';

/**
 * [[VideoSource]] contains the information of a video source.
 */
export default class VideoSource {
  /**
   * The attendee's information for a video source.
   */
  attendee: Attendee;
}
